import React from 'react';
import PropTypes from 'prop-types';
import { Button as ButtonComp } from '@vds/buttons';


const Button = (props) => {
  const { secondary } = props;
  return (
    <ButtonComp {...{ ...props, ...(secondary ? { use: 'secondary' } : {}) }} />
  );
};

Button.defaultProps = {
  display: 'inline-block',
  inverted: false,
  size: 'large',
  width: 'auto',
  use: 'primary',
};
Button.propTypes = {
  use: PropTypes.string,
  disabled: PropTypes.bool,
  display: PropTypes.oneOf(['flex', 'inline-block', 'block']),
  id: PropTypes.string,
  inverted: PropTypes.bool,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'tiny', 'small', 'large', 'block']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, 'auto']),
  children: PropTypes.any,
};
export default Button;
